<template>
  <div>
    <v-form ref="form">
      <v-row class="pb-8">
        <v-col cols="12">
          <p class="mb-6 form__title primary--text">
            SOBRE O CONTATO
          </p>
        </v-col>
        <v-col cols="12" class="pb-5" v-if="isEdit">
          <v-switch
            v-model="formEdit.ativo"
            class="pa-0 ma-0 justify-self-center d-inline-block base-form-switch"
            inset
            hide-details
            dense
            color="secondary"
          />
          <p class="pl-1 mb-0 d-inline-block darkBluishGray--text body-2">
            {{ statusSwitch(form.ativo) }}
          </p>
        </v-col>
        <v-col cols="12">
          <BaseFormInput
            id-element="nameRelationshipContact"
            placeholder="Inserir"
            v-model="formEdit.nome"
            validate-on-blur
            required
            :rules="[requiredInput]"
            label-text="Nome"
          />
        </v-col>
        <v-col cols="12" sm="6" class="pr-sm-5">
          <BaseFormInput
            id-element="emailRelationshipContact"
            placeholder="Inserir"
            v-model="formEdit.email"
            validate-on-blur
            required
            :rules="[requiredInput, isValidEmail]"
            label-text="E-mail"
            :upper-case="false"
          />
        </v-col>
        <v-col cols="12" sm="6">
          <BaseFormInput
            id-element="departamentRelationshipContact"
            placeholder="Inserir"
            v-model="formEdit.departamento"
            validate-on-blur
            required
            :rules="[requiredInput]"
            label-text="Departamento / Cargo"
          />
        </v-col>
        <v-col cols="12" sm="6" md="4" class="pr-sm-5">
          <BaseFormInput
            id-element="firstPhoneRelationshipContact"
            placeholder="Inserir"
            v-model="formEdit.telefone1"
            validate-on-blur
            :rules="[requiredInput, isValidPhoneNumber]"
            v-facade="maskPhone"
            required
            label-text="Comercial"
          />
        </v-col>
        <v-col cols="12" sm="6" md="4">
          <BaseFormInput
            id-element="secondPhoneRelationshipContact"
            placeholder="Inserir"
            v-model="formEdit.telefone2"
            validate-on-blur
            :rules="[isValidPhoneNumber]"
            v-facade="maskPhone"
            label-text="Celular"
          />
        </v-col>
        <v-col cols="12">
          <v-divider />
        </v-col>
      </v-row>
      <v-row class="pb-9" v-if="hasIdRelationshipContact">
        <v-col cols="12">
          <p class="mb-5 form__title primary--text">
            CARTEIRA
          </p>
        </v-col>
        <v-col cols="12" class="pb-5">
          <BaseDataTable
            :headers="header"
            :items="listWalletRelationshipContact"
            loading-text="Carregando Grupos..."
            show-select
            item-key="name"
            v-model="selected"
          >
          </BaseDataTable>
        </v-col>
        <v-col cols="12" sm="6" md="5" lg="4" v-if="selected.length > 0">
          <BaseButton
            v-html="'MIGRAR PARA OUTRO ATENDENTE'"
            width="100%"
            outlined
            color="secondary"
            @click="showModal"
          />
        </v-col>
      </v-row>
      <BaseFooter>
        <v-row>
          <v-spacer />
          <v-col cols="12" sm="5" md="3" class="pb-5 pb-sm-0 pr-sm-5">
            <BaseButton
              v-html="'CANCELAR'"
              color="pink white--text"
              width="100%"
              @click="openModalCancel"
            />
          </v-col>
          <v-col cols="12" sm="5" md="3" class="pb-5 pb-sm-0">
            <BaseButton
              v-html="'SALVAR'"
              color="secondary"
              width="100%"
              @click="submit"
            />
          </v-col>
        </v-row>
      </BaseFooter>
    </v-form>
    <ModalMigrateContact
      @close="closeModal"
      v-model="modal"
      @submit="migrateWallet"
      :list="validListMigrateWallet"
    />
    <ModalCancelContact
      @close="closeModalCancel"
      v-model="modalCancelContact"
      title="SAIR SEM SALVAR"
      text="As alterações não foram salvas. Deseja realmente sair da tela?"
    />
  </div>
</template>
<script>
const tableHeaders = [
  { text: "Selecionar todos os Grupos", value: "nome", sortable: true }
];
import ModalMigrateContact from "../components/ModalMigrateContact";
import { InsuranceCompanyMixin } from "@/mixins/NewInsuranceCompanyMixin";
import {
  requiredInput,
  isValidPhoneNumber,
  isValidEmail
} from "@/utils/rules.js";
import { maskPhone } from "@/utils/masks.js";
import { SwitchText } from "@/mixins/SwitchMixin.js";
import { mapState, mapActions } from "vuex";
import { LoadingRequest } from "@/mixins/LoadingMixin";
import ModalCancelContact from "../../insurance_company/components/ModalCancelInsurance";
import _ from "lodash";
const MOCKFORM = {
  ativo: true,
  nome: null,
  email: null,
  telefone1: null,
  telefone2: null,
  departamento: null
};
export default {
  data: () => ({
    selected: [],
    header: tableHeaders,
    requiredInput,
    modal: false,
    maskPhone,
    isValidPhoneNumber,
    isValidEmail,
    newContact: null,
    isEdit: false,
    modalCancelContact: false,
    formEdit: {}
  }),
  components: {
    ModalMigrateContact,
    ModalCancelContact
  },
  mixins: [InsuranceCompanyMixin, SwitchText, LoadingRequest],
  created() {
    this.formEdit = _.cloneDeep(this.form);
  },
  mounted() {
    this.isEdit = Boolean(this.formEdit.nome);
    if (this.hasIdRelationshipContact) this.fetchWallet();
  },
  computed: {
    ...mapState("insuranceCompany", ["listWalletRelationshipContact"]),
    formStep() {
      return {
        name: "insurance_company step form",
        step: 1
      };
    },
    hasIdRelationshipContact() {
      return this.formEdit.id;
    },
    validListMigrateWallet() {
      return this.insurance.contatos_relacionamento.filter(
        x => x.id !== this.formEdit.id
      );
    }
  },
  methods: {
    ...mapActions("insuranceCompany", [
      "requestWalletRelationshipContact",
      "updateMigrateWalletRelationshipContacts"
    ]),
    fetchWallet() {
      this.withLoading(
        this.requestWalletRelationshipContact(this.getPayloadWalltet())
      );
    },
    getPayloadWalltet() {
      return {
        seguradora: this.$route.params.id,
        contato: this.formEdit.id,
        payload: {
          grupos_economicos_ids: this.getSelectedEconomicGroup(),
          novo_contato_relacionamento_id: this.newContact
        }
      };
    },
    getSelectedEconomicGroup() {
      let payload = [];
      this.selected.forEach(item => {
        payload.push(item.id);
      });
      return payload;
    },
    migrateWallet(value) {
      this.modal = false;
      this.newContact = value;
      this.withLoading(
        this.updateMigrateWalletRelationshipContacts(this.getPayloadWalltet())
      );
    },
    showModal() {
      this.modal = true;
    },
    closeModal() {
      this.modal = false;
    },
    previousStep() {
      this.$emit(
        "updateStep",
        this.payloadInsuranceCompany(MOCKFORM, this.formStep)
      );
    },
    submit() {
      if (this.$refs.form.validate())
        // TODO: fazer atualizacao na tabela de contatos
        // de relacionamento (back-end), por hora apenas
        // vou atualizar o componente que será renderizado
        this.$emit(
          "updateContact",
          this.payloadInsuranceCompany(this.formEdit, this.formStep),
          this.form
        );
    },
    openModalCancel() {
      this.modalCancelContact = true;
    },
    closeModalCancel(value) {
      this.cancel = value;
      this.modalCancelContact = false;
      if (value) {
        this.previousStep();
      } else {
        this.$emit("setReturnFalse");
      }
    }
  },
  props: {
    return: {
      type: Boolean
    },
    form: {
      type: Object
    },
    insurance: {
      type: Object
    }
  },
  watch: {
    return(value) {
      value && this.openModalCancel();
    }
  }
};
</script>
